<template>
  <div>
    <span>{{ params.data.carrier.name }} </span>
    <feather-icon icon="TruckIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="save_changes" title="Trocar para Correios" v-if="params.data.carrier.name !== 'CORREIOS'" />
  </div>
</template>
<script>
export default {
  name: 'CellRendererCarrier',
  methods: {
    save_changes() {

      return new Promise(() => {
        this.$validator.validateAll().then(result => {
          if (result) {

            this.$vs.loading();

            const pkg = {
              carrier: {
                name: 'CORREIOS',
                kind: this.$store.state.sigep.info.equivalents._default,
                currency: 'BRL',
                price: this.params.data.carrier.price,
              }
            };

            console.log({pkg});

            const id = this.params.data.id;

            this.$store.dispatch("packageManagement/updatePackage", { id, pkg })
              .then(res => {

                // console.log({ res })

                const carrier = res.data.tracking.carrier;
                const label_error = res.data.tracking.label_error;

                if (carrier == 'CORREIOS' && label_error == "") {

                  this.$vs.notify({
                    time: 20000,
                    title: 'Tudo ok!',
                    text: 'Pedido atualizado.',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                  })

                } else {

                  this.$vs.notify({
                    time: 20000,
                    title: 'Pedido atualizado, porém houve um <strong>erro</strong> na geração da etiqueta:',
                    text: `${label_error ? label_error : 'Endereço inválido: remova todos os caracteres que não sejam letras e números.'}`,
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                  })

                }

                this.$vs.loading.close();
              })
              .catch(err => {


                // console.error({ err: err.response })

                this.$vs.notify({
                  time: 20000,
                  title: 'Atenção',
                  text: `${err.response.data.message}`,
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })

                this.$vs.loading.close();

              })
            // if form have no errors

          }
        })
      })

    }
  },
}

</script>
<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), .15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }

  &.vs-chip-warning {
    background: rgba(var(--vs-warning), .15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }

  &.vs-chip-danger {
    background: rgba(var(--vs-danger), .15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}

</style>
